import React from 'react';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import './MostrarDadosEstabelecimento.css'; // Certifique-se de ter um arquivo CSS adequado para este componente
import 'bootstrap/dist/css/bootstrap.min.css';  // Importando o CSS do Bootstrap


const MostrarDadosEstabelecimento = () => {
    const location = useLocation();
    const navigate = useNavigate();

    console.log("Dados recebidos:", location.state);  // Debug

    const { estabelecimento } = location.state || {};
  
    return (
      <div className="mostrar-dados-estabelecimento-container">
        <TituloComponent /> {/* Adiciona o título fixo no topo */}


        <div>
          <h1 className="mostrar-dados-estabelecimento-title">Dados do Estabelecimento</h1>
          {/* Conteúdo da página de Buscar */}


          {estabelecimento ? (
            <div>
              <p><strong>Nome:</strong> {estabelecimento.nome}</p>
              <p><strong>Detalhes:</strong> {estabelecimento.detalhes}</p>
            </div>
          ) : (
            <p>Estabelecimento não encontrado.</p>
          )}
          <button className="voltar-btn-bootstrap btn" onClick={() => navigate('/')}>Voltar</button>


        </div>


      
      </div>
    );
  };

export default MostrarDadosEstabelecimento;
